import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backLinkTemplate"]

  connect() {
    this.abortController = new AbortController()
    const signal = this.abortController.signal

    this.element.querySelectorAll('.submenu').forEach(item => {
      const submenuContent = item.querySelector('.submenu-content')
      if (!submenuContent) return

      const clone = this.backLinkTemplateTarget.content.cloneNode(true)
      submenuContent.prepend(clone)

      item.querySelector('a').addEventListener('click', (e) => {
        e.preventDefault()
        item.classList.add('active')
      }, { signal })

      item.querySelector('.back-link').addEventListener('click', (e) => {
        e.preventDefault()
        item.classList.remove('active')
      }, { signal })
    })

    const path = window.location.pathname
    const links = this.element.querySelectorAll('a[href]')
    let bestLink = null
    let bestHref = ''
    for (const link of links) {
      if (link.getAttribute('href')?.startsWith('#')) continue
      const parsed = new URL(link.href, window.location.origin)
      if (parsed.origin !== window.location.origin) continue
      const href = parsed.pathname
      if ((href === path || (href !== '/' && path.startsWith(href + '/'))) && href.length > bestHref.length) {
        bestLink = link
        bestHref = href
      }
    }
    if (bestLink) {
      let li = bestLink.closest('li')
      while (li) {
        li.classList.add('active')
        li = li.parentElement?.closest('li.submenu')
      }
    }
  }

  disconnect() {
    this.abortController.abort()
    this.element.querySelectorAll('.back-link').forEach(el => el.closest('li')?.remove())
  }
}
